import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const AttachmentIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8 22.99a6.96 6.96 0 0 1-7-7c0-1.87.73-3.63 2.05-4.95l8.57-8.57a5 5 0 1 1 7.09 7.07l-8.59 8.57a3.1 3.1 0 0 1-4.24 0 3.01 3.01 0 0 1 0-4.24l8.48-8.48a1 1 0 1 1 1.41 1.41l-8.49 8.48a.99.99 0 0 0-.29.71c0 .27.11.52.29.71.38.37 1.04.38 1.42 0l8.59-8.57a3.01 3.01 0 0 0 0-4.24 2.97 2.97 0 0 0-4.24 0l-8.58 8.56a5 5 0 1 0 7.08 7.08l9.19-9.19a1 1 0 1 1 1.41 1.41l-9.19 9.19a6.96 6.96 0 0 1-4.95 2.05H8Z" />
    </Icon>
  )
);
export default AttachmentIcon;
